import type { PermissionDefinition } from '@proposify/users-bff-api-client';

export enum PermissionCategory {
  DOCUMENTS = 'documents',
  CONTENT_LIBRARY = 'content_library',
  SETTINGS = 'settings',
  AUTOMATIONS = 'automations',
}

export interface UpdatePermissionRequest {
  roleId: string;
  roleName: string;
  payload: UpdatePermissionPayload;
  allPermissions: Record<string, PermissionValue>;
  definitions: PermissionDefinition[];
  /** Carried forward on every update so an unrelated toggle doesn't clear document_approval_required's approvers */
  documentApproverUserIds?: string[];
}

export interface UpdatePermissionPayload {
  permissionId: string;
  enabled?: boolean;
  dropdownValue?: string;
}

export type PermissionValue = boolean | string;

export interface RolePermissionsResponse {
  roleId: string;
  permissions: Record<string, PermissionValue>;
  /** Parsed from document_approval_required's grant conditions */
  documentApproverUserIds?: string[];
}

export interface AddPermissionToRoleRequest {
  roleId: string;
  roleName: string;
  accountId: string;
  permissionId: string;
  domainId: string;
  enabled: boolean;
}

export interface SystemRoleData {
  id: string;
  name: string;
  permissions: Record<string, PermissionValue>;
}
